export default class DefaultState{
  resetPasswordError: string|null = null;
  email = '';
  resetPasswordRequested = false;
  token: string|null = null;
  password = '';
  rePassword = '';
}
